import { defineField, defineType } from 'sanity'
import { richTextContent } from '../../data/richText'
import extractTextFromRichText from '../../utils/extractFromRichText'

export default defineType({
  title: 'Rich text',
  name: 'richText',
  type: 'object',
  fields: [
    defineField({
      name: 'content',
      type: 'array',
      of: richTextContent,
    }),
    defineField({
      name: 'readMore',
      title: 'Read more',
      type: 'boolean',
      initialValue: false,
      description:
        'Only first part of the content will be visible, the rest will be hidden behind a "Read more" button',
    }),
  ],
  preview: {
    select: {
      blocks: 'content',
    },
    prepare({ blocks }) {
      const title = extractTextFromRichText(blocks) || 'Rich text content'

      return {
        title,
        subtitle: 'Rich text',
      }
    },
  },
})
